import { Component, Input, OnInit, forwardRef } from '@angular/core';
import {
	NG_VALUE_ACCESSOR,
	ControlValueAccessor
} from '@angular/forms';

@Component({
	selector: 'app-large-input-select',
	templateUrl: './large-input-select.indra.component.html',
	styleUrls: ['./large-input-select.component.scss'],
	host: { class: 'app-large-input-select' },
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			multi: true,
			useExisting: forwardRef(() => LargeInputSelectComponent)
		}
	]
})

export class LargeInputSelectComponent implements OnInit, ControlValueAccessor {
	@Input() id;
	@Input() label;
	@Input() placeholderLabel;
	@Input() icon;
	@Input() required = false;
	@Input() inputValue: String = '';
	@Input() inputOptions = [
		{
			value: String,
			label: String
		}
	];
	@Input() disabled = false;
	@Input() errorMessage;
	@Input() hasError;
	@Input() isLoading = false;
	@Input() ariaDescribedby = null;
	@Input() readonly = false;
	
	@Input() showActiveColor: boolean = false; // Show background color on input when option is selected

	isFilled = false;
	isFocused = false;

	@Input() asyncOptionLabels = false; // pass true value to this input if label must be async for translation purposes..

	ngOnInit() {
		if (this.inputValue !== '') {
			this.isFilled = true;
		} else {
			this.isFilled = false;
		}
	}

	change($event) {
		this.inputValue = $event.target.value;
		this.writeValue($event.target.value); // sprint 2 merge
	}
	TAP_printID() {
		return this.id;
	}

	TAP_printIcon() {
		return this.icon;
	}

	TAP_printLabel() {
		return this.placeholderLabel && !this.isFilled ? this.placeholderLabel : this.label;
	}

	TAP_printStyle() {
		return {
			'is-filled': this.isFilled && !this.isLoading,
			'is-focused': this.isFocused && !this.isLoading,
			'is-loading': this.isLoading,
			'is-disabled': this.disabled && !this.isLoading,
			'has-error' : this.hasError,
			'has-icon' : this.icon,
			'active-background-color': this.isFilled && !this.isLoading && this.showActiveColor,
		};
	}

	INDRA_printOptionStyle(option: any) {
		return {
			'dropdown-option': this.inputValue !== option.value
		  };
	}

	TAP_handleFocus($event) {
		this.isFocused = true;
	}

	TAP_handleBlur($event) {
		this.isFocused = false;
		if ($event.target.value !== '') {
			this.isFilled = true;
		} else {
			this.isFilled = false;
		}
		this.writeValue($event.target.value);
	}

	TAP_showError() {
		return this.hasError;
	}

	// Function to call when the rating changes.
	onChange = (value) => {};

	// Function to call when the input is touched (when a star is clicked).
	onTouched = () => {};

	// Allows Angular to update the model (rating).
	// Update the model and changes needed for the view here.
	writeValue(value): void {
		this.onChange(value);
	}

	// Allows Angular to register a function to call when the model (rating) changes.
	// Save the function as a property to call later here.
	registerOnChange(fn: (rating: number) => void): void {
		this.onChange = fn;
	}

	// Allows Angular to register a function to call when the input has been touched.
	// Save the function as a property to call later here.
	registerOnTouched(fn: () => void): void {
		this.onTouched = fn;
	}

	// Allows Angular to disable the input.
	setDisabledState(isDisabled: boolean): void {
		this.disabled = isDisabled;
	}

	TAP_printError() {
		return this.errorMessage;
	}

	TAP_isRequired() {
		return this.required;
	}
}
